define('TescoMobile_ClubCard/js/view/minicart/cart-item-renderer-mixin',['jquery'], function ($) {
  'use strict';

  return function (renderer) {
    return renderer.extend({
      initialize: function () {
        this._super();
        this.extensionTemplates.device.push('TescoMobile_ClubCard/minicart/clubcard/device');
        this.extensionTemplates.tariff.push('TescoMobile_ClubCard/minicart/clubcard/tariff');
        this.extensionTemplates.monthly.push('TescoMobile_ClubCard/minicart/clubcard/monthly');
        this.extensionTemplates.today.push('TescoMobile_ClubCard/minicart/clubcard/today');
        this.extensionTemplates.upfront.push('TescoMobile_ClubCard/minicart/clubcard/aui');
        var elemTariff = $(".cart .tariff-info .sub-item");
        var elemTariffSuccess = $(".checkout-onepage-success .cart .tariff-info .payment-item.sub-item");
        var elemDevice = $(".cart .device-payment .sub-item");
        elemTariffSuccess.each(function () {
          if ($(this).hasClass('ccp')) {
            $(this).prev().addClass('old-price');
          }
        });
        elemTariff.each(function () {
          if ($(this).hasClass('ccp')) {
            $(this).prev('.sub-item').children('.price').addClass('old-price');
          }
        });
        elemDevice.each(function () {
          if ($(this).hasClass('ccp')) {
            $(this).prev().children('.payment-price').addClass('old-price');
          }
        });
      }
    });
  };
});

